import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-30 14:00:34
 * @LastEditTime: 2020-12-30 17:20:29
 */
import Login from '../login';
import loginStatus from '../../common/loginStatus';
import object from '../../common/object';
import loader from '../../common/loader';
import ATM from '../../util/atm';
import _getRoleResult from './resolver';
export var requestRole = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
    var LoginManager;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 检查登录态
            LoginManager = new Login();
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              // jsonp 实现跨域请求
              var sRoleInfoUrl = opts.sRoleInfoUrl,
                  submitData = opts.submitData,
                  gameId = opts.gameId,
                  request = opts.request,
                  iActivityId = opts.iActivityId,
                  charset = opts.charset;
              var rand = "".concat(new Date().getTime()).concat(Math.floor(Math.random() * 20000));
              var callbackName = "query_role_result_".concat(rand);
              submitData.callback = rand;
              var game2Url = {
                cf: "".concat(location.protocol, "//cf.aci.game.qq.com/main"),
                lol: "".concat(location.protocol, "//lol.aci.game.qq.com/main"),
                yxzj: "".concat(location.protocol, "//yxzj.aci.game.qq.com/main")
              };
              var urlDefault = "".concat(location.protocol, "//comm.aci.game.qq.com/main"); // url

              var url = sRoleInfoUrl ? sRoleInfoUrl : game2Url[gameId] ? game2Url[gameId] : urlDefault;
              var extendParams = {};

              if (LoginManager.isMSDKLogin()) {
                var oMSDKLoginParams = LoginManager.getMSDKParams();
                extendParams = oMSDKLoginParams;
              }

              var sParams = object.serialize(_objectSpread(_objectSpread({}, submitData), extendParams));

              if (url.indexOf('?') > -1) {
                url += "&".concat(sParams);
              } else {
                url += "?".concat(sParams);
              }

              LoginManager.checkLogin().then(function () {
                loginStatus.syncToAME(function () {
                  var timecostStart = new Date().getTime();
                  loader.loadScript({
                    url: url,
                    charset: 'gbk'
                  }).then(function () {
                    var oriRoleData = window[callbackName]; // add by weiztang Milo调试系统上报支持

                    window.MiloDebug && window.MiloDebug.setJsonp && window.MiloDebug.setJsonp(url, oriRoleData);
                    var retCode = oriRoleData.retCode,
                        msg = oriRoleData.msg,
                        data = oriRoleData.data,
                        serialnum = oriRoleData.serial_num;
                    var atmResult = retCode;
                    var atmErrormsg = msg;

                    if (0 == atmResult) {
                      try {
                        atmResult = object.unSerialize(data, 1)._webplat_msg_code;
                        atmErrormsg = object.unSerialize(data, 1)._webplat_msg;
                      } catch (e) {
                        console.log(e);
                      }
                    }

                    var timecostEnd = new Date().getTime();
                    ATM.reportATM({
                      toappid: 25,
                      tomoduletype: 1,
                      tointer: 43,
                      toreturncode: retCode == 0 ? 0 : 1,
                      businesstype: gameId,
                      result: atmResult,
                      serialnum: serialnum,
                      actid: iActivityId,
                      errormsg: atmErrormsg,
                      timecost: timecostEnd - timecostStart,
                      tonode: url
                    }); // 错误码处理

                    if (-1019 == retCode) {
                      // wegame登录态过期
                      LoginManager.refreshWegame(function () {
                        requestRole(url);
                      }, function () {
                        // 续期失败
                        reject({
                          iRet: 1,
                          // 未登录
                          sMsg: '未登录或登录态过期，请重新登录',
                          retCode: retCode,
                          err: oriRoleData
                        });
                      });
                      return;
                    }

                    if (0 != retCode) {
                      var _sMsg = msg;
                      var _iRet = 2;

                      if (msg.indexOf('未登录') > -1) {
                        _iRet = 1;
                      }

                      reject({
                        iRet: _iRet,
                        sMsg: _sMsg,
                        retCode: retCode,
                        err: oriRoleData
                      });
                      return;
                    } // 成功回调，执行角色解析


                    var checkparam = oriRoleData.checkparam,
                        md5str = oriRoleData.md5str;

                    var _getRoleResult2 = _getRoleResult(gameId)(oriRoleData, request, charset),
                        iRet = _getRoleResult2.iRet,
                        sMsg = _getRoleResult2.sMsg,
                        arrRole = _getRoleResult2.arrRole;

                    var result = {
                      iRet: iRet,
                      // 0 OK  1 未登录  2 查询人数过多  3.无角色
                      sMsg: sMsg,
                      request: request,
                      checkparam: checkparam,
                      md5str: md5str,
                      gameId: gameId,
                      roleArray: arrRole,
                      oriRoleData: oriRoleData
                    };
                    resolve(result);
                  })["catch"](function (err) {
                    reject({
                      iRet: -99,
                      // 超时
                      sMsg: '查询角色超时，请重试',
                      roleData: null,
                      err: err
                    });
                  });
                });
              })["catch"](function (err) {
                reject({
                  iRet: 1,
                  // 1 未登录  2 其它  -99 超时
                  sMsg: '未登录或登录态过期，请重新登录',
                  retCode: '',
                  err: err
                });
              });
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function requestRole(_x) {
    return _ref.apply(this, arguments);
  };
}();